/**
 * appParams — single place to read the viewer's launch parameters.
 *
 * Accepts parameters from BOTH the query string (?url=...) and the URL
 * fragment (#url=...). The fragment form exists because the document
 * URL we carry (e.g. a signed Azure Blob SAS) makes the full page URL
 * look credential-laden to Chrome's real-time Safe Browsing checks,
 * which were interstitialing the viewer ("Dangerous site", 2026-07-17).
 * Fragments are never sent to the server or to Google's URL checks, so
 * callers switched to `#params`; the query form remains supported for
 * legacy callers (Fortegra Smart Folders).
 *
 * Query-string values win on key collision (legacy behavior preserved).
 */
export function getAppParams() {
  const merged = new URLSearchParams(window.location.search);
  const rawHash = (window.location.hash || "").replace(/^#\/?/, "");
  if (rawHash.includes("=")) {
    const hashParams = new URLSearchParams(rawHash);
    for (const [k, v] of hashParams.entries()) {
      if (!merged.has(k)) merged.append(k, v);
    }
  }
  return merged;
}

export default getAppParams;
